// Deferred scripts execute in order: data, designs, editor, commerce.
PRODUCT_PALETTE.papers.forEach(p => p.texture = window.FF_ASSETS[p.texture]);
DESIGN_TEMPLATES.forEach(t => {t.thumbnail = window.FF_ASSETS[t.thumbnail]; t.fixedTexture = window.FF_ASSETS[t.fixedTexture];(t.staticLayers||[]).forEach(l=>l.asset=window.FF_ASSETS[l.asset]); (t.motifOptions||[]).forEach(o=>o.asset=window.FF_ASSETS[o.asset]);});
/* Product builder; palette source and sampling method are in product-v2-data.js. */
const $ = (id) => document.getElementById(id);
const mobileEditorQuery = window.matchMedia('(max-width: 680px)');
let mobileLibraryExpanded = false, mobilePopoverSource = null, mobilePopoverAnchor = null, popoverTrigger = null, savedBodyOverflow = '';
const colorMap = Object.fromEntries(PRODUCT_PALETTE.papers.map((item) => [item.key, item]));
const finishMap = Object.fromEntries(PRODUCT_PALETTE.finishes.map((item) => [item.key, item]));
const productState = { size: 'cocktail', color: 'burgundy', finish: 'gold', printColor: '#222222', quantity: '50', view: 'product' };
let activeTemplate = DESIGN_TEMPLATES[0];
let activeTheme = 'all';
const templateValues = Object.fromEntries(DESIGN_TEMPLATES.map((template) => [template.key, Object.fromEntries(template.fields.map((field) => [field.key, field.value]))]));
const templateLayouts = Object.fromEntries(DESIGN_TEMPLATES.map(t => [t.key, {angle:0,scale:1,canvasSize:t.canvasSize,offsets:{},textScales:{},...(t.motifOptions?.length ? {motif:t.motifOptions[0].value} : {})}]));
let selectedLayer = null, layerMeasurements = [];
let selectedSize = 'Cocktail · 9.8 × 9.8 inches';
let selectedColor = colorMap.burgundy.name;
let selectedColorCode = colorMap.burgundy.hex;
let selectedFinish = finishMap.gold.name;
let selectedFinishCode = finishMap.gold.body;
let selectedQuantity = '50';
const finishShortNames = {gold:'Gold',silver:'Silver',red:'Red',green:'Green',blue:'Blue',purple:'Purple',rose:'Rose Gold',print:'Matte Ink Print'};
function displayFinishName() {
  if (productState.finish === 'print') return 'Matte Ink — ' + ($('printInkColor')?.selectedOptions?.[0]?.textContent || 'Black');
  return finishShortNames[productState.finish] || selectedFinish;
}

function currentFinish() {
  const base=finishMap[productState.finish];
  return productState.finish==='print' ? {...base,body:productState.printColor,dark:productState.printColor,highlight:productState.printColor} : base;
}
function requiresUVInk() {
  if(productState.finish!=='print') return false;
  const brightness=hex=>{const c=hex.replace('#','');const rgb=[0,2,4].map(i=>parseInt(c.slice(i,i+2),16)/255);return rgb[0]*.2126+rgb[1]*.7152+rgb[2]*.0722;};
  return brightness(selectedColorCode)<.60 && brightness(productState.printColor)>.75;
}
function syncPrintControls(resetConsent=false) {
  const panel=$('printColorPanel'); if(!panel)return;
  panel.hidden=productState.finish!=='print';
  const needsConsent=requiresUVInk(), notice=$('uvInkNotice'), consent=$('uvInkConsent');
  notice.hidden=productState.finish!=='print';
  notice.classList.toggle('needs-consent',needsConsent);
  consent.disabled=!needsConsent;
  consent.closest('label').setAttribute('aria-hidden',String(!needsConsent));
  if(resetConsent)$('uvInkConsent').checked=false;
  selectedFinish=productState.finish==='print' ? 'Classic Print — '+$('printInkColor').selectedOptions[0].textContent : finishMap[productState.finish].name;
}
function renderOptions() {
  const paperGrid = $('paperColorGrid');
  for (const paper of PRODUCT_PALETTE.papers) {
    const button = document.createElement('button');
    button.type = 'button'; button.className = 'color-swatch'; button.dataset.color = paper.key;
    button.setAttribute('aria-label', paper.name); button.title = paper.name;
    button.style.setProperty('--swatch', paper.hex);
    const dot = document.createElement('span'); dot.className = 'swatch-dot';
    const label = document.createElement('span'); label.className = 'swatch-name'; label.textContent = paper.name;
    button.append(dot, label); button.addEventListener('click', () => selectColor(button)); paperGrid.appendChild(button);
  }
  const finishGrid = $('finishGrid');
  for (const finish of PRODUCT_PALETTE.finishes) {
    const button = document.createElement('button');
    button.type = 'button'; button.className = 'finish-card'; button.dataset.finish = finish.key;
    button.setAttribute('aria-label', finish.name);
    const sample = document.createElement('span'); sample.className = 'finish-material';
    for (const [property, value] of [['--foil-dark', finish.dark], ['--foil-body', finish.body], ['--foil-highlight', finish.highlight]]) sample.style.setProperty(property, value);
    const name = document.createElement('span'); name.className = 'finish-name'; name.textContent = finishShortNames[finish.key] || finish.name;
    button.append(sample, name); button.addEventListener('click', () => selectFinish(button)); finishGrid.appendChild(button);
  }
  renderTemplates();
  syncOptionSelection();
}
function syncOptionSelection() {
  document.querySelectorAll('.size-btn').forEach((button) => button.classList.toggle('active', button.dataset.size === productState.size));
  document.querySelectorAll('.color-swatch').forEach((button) => button.classList.toggle('active', button.dataset.color === productState.color));
  document.querySelectorAll('.finish-card').forEach((button) => button.classList.toggle('active', button.dataset.finish === productState.finish));
  document.querySelectorAll('.quantity-btn').forEach((button) => button.classList.toggle('active', button.dataset.qty === productState.quantity));
}
function updateSummary() {
  syncPrintControls();
  $('summarySize').textContent = mobileEditorQuery.matches ? selectedSize.split(' ·')[0] : selectedSize;
  $('summaryColor').textContent = selectedColor;
  $('selectedPaperName').textContent = selectedColor;
  $('selectedFinishName').textContent = displayFinishName();
  $('summaryFinish').textContent = displayFinishName();
  $('summaryQuantity').textContent = selectedQuantity;
  document.dispatchEvent(new Event('ff:configuration'));
}
function setMaterialVariables(element) {
  const finish = currentFinish();
  element.style.setProperty('--paper', selectedColorCode);
  element.style.setProperty('--paper-image', `url("${colorMap[productState.color].texture}")`);
  element.style.setProperty('--foil-dark', finish.dark);
  element.style.setProperty('--foil-body', finish.body);
  element.style.setProperty('--foil-highlight', finish.highlight);
}
function updateMainImageTreatment() {
  const finish = currentFinish();
  for (const element of [$('productNapkin'), $('canvasNapkin'), $('miniNapkin')]) setMaterialVariables(element);
  $('productStage').setAttribute('aria-label', `${selectedColor} paper napkin with ${finish.name} design preview`);
  $('miniNapkin').style.color = finish.body;
  renderDesignPreviews();
  showProductView();
}
function setActiveThumbnail(thumb) {
  document.querySelectorAll('.thumbnail').forEach((item) => item.classList.toggle('active', item === thumb));
}
function showProductView() {
  productState.view = 'product';
  $('productNapkin').style.width=(productState.size==='cocktail'?76*25/33:76)+'%';
  $('mainImageFrame').classList.remove('scene-view');
  setActiveThumbnail($('productThumbnail'));
}
function changeMainImage(thumb, src) {
  productState.view = 'scene';
  const image = $('mainImage'); image.src = src;
  image.alt = thumb?.querySelector('img')?.alt || 'Napkin scene photograph';
  image.style.filter = 'none';
  $('mainImageFrame').classList.add('scene-view');
  setActiveThumbnail(thumb);
}
function selectSize(button) {
  productState.size = button.dataset.size;
  const source = document.querySelector(`#sizeOptions .size-btn[data-size="${productState.size}"]`);
  selectedSize = productState.size === 'cocktail' ? 'Cocktail · 9.8 × 9.8 inches' : 'Luncheon · 13 × 13 inches';
  syncOptionSelection(); updateMainImageTreatment(); updateSummary();
}
function selectColor(button) {
  const paper = colorMap[button.dataset.color]; if (!paper) return;
  productState.color = paper.key; selectedColor = paper.name; selectedColorCode = paper.hex; syncPrintControls(true);
  syncOptionSelection(); updateMainImageTreatment(); updateSummary();
}
function selectFinish(button) {
  const finish = finishMap[button.dataset.finish]; if (!finish) return;
  productState.finish = finish.key; selectedFinish = finish.name; selectedFinishCode = finish.body; syncPrintControls(true);
  syncOptionSelection(); updateMainImageTreatment(); updateSummary();
}
function selectQuantity(button) {
  productState.quantity = button.dataset.qty;
  selectedQuantity = productState.quantity;
  syncOptionSelection(); updateSummary();
}
function scrollToEditor() { $('designEditor').scrollIntoView({ behavior: 'smooth', block: 'start' }); }
function showPopover(type) {
  const source = ({ size: 'sizeOptions', color: 'colorOptions', finish: 'finishOptions', quantity: 'quantityOptions' })[type];
  if (!source) return;
  closePopover();
  const body = $('popoverBody');
  if (mobileEditorQuery.matches) {
    popoverTrigger=document.querySelector(`.summary-item[data-type="${type}"]`);
    mobilePopoverSource=$(source);mobilePopoverAnchor=document.createComment('options home');
    mobilePopoverSource.before(mobilePopoverAnchor);body.replaceChildren(mobilePopoverSource);
    const content=$('popoverContent');content.setAttribute('role','dialog');content.setAttribute('aria-modal','true');content.setAttribute('aria-label',({size:'Size',color:'Napkin color',finish:'Finish',quantity:'Quantity'})[type]);
    savedBodyOverflow=document.body.style.overflow;document.body.style.overflow='hidden';
    $('popoverOverlay').classList.add('active');content.querySelector('.popover-close').focus({preventScroll:true});return;
  }
  body.innerHTML = $(source).innerHTML;
  body.querySelectorAll('[onclick]').forEach((item) => item.removeAttribute('onclick'));
  body.querySelectorAll('[id]').forEach((item) => item.removeAttribute('id'));
  for (const [selector, handler] of [['.size-btn', selectSize], ['.color-swatch', selectColor], ['.finish-card', selectFinish], ['.quantity-btn', selectQuantity]]) {
    body.querySelectorAll(selector).forEach((button) => button.addEventListener('click', () => { handler(button); closePopover(); }));
  }
  const item = document.querySelector(`.summary-item[data-type="${type}"]`), rect = item?.getBoundingClientRect();
  const content = $('popoverContent');
  if (rect) {
    const width = Math.min(560, window.innerWidth - 32);
    const left = Math.max(16, Math.min(rect.left, window.innerWidth - width - 16));
    content.style.setProperty('--popover-left', `${left}px`);
    content.style.setProperty('--popover-top', `${Math.min(rect.bottom + 10, window.innerHeight - 140)}px`);
  }
  $('popoverOverlay').classList.add('active');
}
function closePopover() {
  $('popoverOverlay').classList.remove('active');
  if(mobilePopoverSource){mobilePopoverAnchor.replaceWith(mobilePopoverSource);mobilePopoverSource=null;mobilePopoverAnchor=null;document.body.style.overflow=savedBodyOverflow;}
  const content=$('popoverContent');content.removeAttribute('role');content.removeAttribute('aria-modal');content.removeAttribute('aria-label');
  if(popoverTrigger){popoverTrigger.focus({preventScroll:true});popoverTrigger=null;}
}
function syncMobileLibrary() {
  const toggle=$('mobileDesignToggle'), library=$('designTemplates');if(!toggle||!library)return;
  toggle.hidden=!mobileEditorQuery.matches;$('mobileDesignName').textContent=activeTemplate.name;
  const collapsed=mobileEditorQuery.matches&&!mobileLibraryExpanded;
  library.hidden=collapsed;library.inert=collapsed;library.setAttribute('aria-hidden',String(collapsed));toggle.setAttribute('aria-expanded',String(!collapsed));
}
function initMobileEditor() {
  const add=$('designEditor').querySelector('.canvas-actions [data-shopify-add]');
  const home=document.createComment('cart button home');add.before(home);
  const preview=$('mobilePreviewJump');
  const adapt=()=>{
    closePopover();syncMobileLibrary();preview.hidden=!mobileEditorQuery.matches;
    if(mobileEditorQuery.matches)$('shopifyOrderStatus').before(add);else home.after(add);
    $('summarySize').textContent=mobileEditorQuery.matches?selectedSize.split(' ·')[0]:selectedSize;
  };
  $('mobileDesignToggle').addEventListener('click',()=>{mobileLibraryExpanded=!mobileLibraryExpanded;syncMobileLibrary();if(mobileLibraryExpanded)revealSelectedTemplate();});
  preview.addEventListener('click',()=>{$('canvasNapkin').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});});
  $('popoverBody').addEventListener('click',event=>{if(!mobilePopoverSource)return;const choice=event.target.closest('.size-btn,.color-swatch,.finish-card,.quantity-btn');if(choice && choice.dataset.finish!=='print')closePopover();});
  document.addEventListener('keydown',event=>{
    if(!mobilePopoverSource)return;
    if(event.key==='Escape'){event.preventDefault();closePopover();return;}
    if(event.key==='Tab'){const controls=[...$('popoverContent').querySelectorAll('button,input,select,textarea,[tabindex="0"]')].filter(e=>!e.disabled&&e.getClientRects().length);const first=controls[0],last=controls.at(-1);if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}}
  });
  mobileEditorQuery.addEventListener('change',adapt);adapt();
}
function renderTemplates() {
  const container = $('designTemplates');
  container.replaceChildren();
  for (const template of DESIGN_TEMPLATES) {
    const button = document.createElement('button');
    button.type = 'button'; button.className = 'template-item'; button.dataset.template = template.key;
    button.classList.toggle('active', template.key === activeTemplate.key);
    button.setAttribute('aria-pressed', String(template.key === activeTemplate.key));
    button.addEventListener('click', () => selectTemplate(template.key));
    const preview = document.createElement('span'); preview.className = 'template-preview';
    const image = document.createElement('img'); image.src = template.thumbnail; image.alt = `${template.name} preview`; image.loading = 'lazy';
    preview.append(image);
    const name = document.createElement('span'); name.className = 'template-name'; name.textContent = template.name;
    const description = document.createElement('span'); description.className = 'template-desc'; description.textContent = template.description;
    button.append(preview, name, description); container.append(button);
  }
  applyTemplateFilters();
}
const occasionDesigns = {
  wedding: DESIGN_TEMPLATES.filter(t => t.category === 'wedding').map(t => t.key),
  weekend: ['nk101','nk102','nk106','nk107','nk108','nk110','nk111','nk113','nk114'],
  family: ['nk103','nk104','nk105','nk109','nk112','nk115','nk116','nk127','nk129'],
  party: ['nk107','nk108','nk110','nk112','nk114','nk115','nk127','nk128'],
  business: ['nk108','nk110','nk114'],
};
function applyTemplateFilters() {
  const container = $('designTemplates');
  if (!container) return;
  container.classList.add('is-open');
  container.setAttribute('aria-hidden', 'false');
  document.querySelectorAll('.template-item').forEach(item => { item.hidden = false; });
}
function renderGuideDesigns(theme) {
  const guide = $('guideDesigns'), track = $('guideDesignTrack'), count = $('guideDesignCount');
  if (!guide || !track) return;
  if (!theme || theme === 'all') { guide.hidden = true; track.replaceChildren(); return; }
  const keys = occasionDesigns[theme] || [];
  const templates = keys.map(key => DESIGN_TEMPLATES.find(template => template.key === key)).filter(Boolean);
  track.replaceChildren();
  templates.forEach(template => {
    const card = document.createElement('button');
    card.type = 'button'; card.className = 'guide-design-card'; card.dataset.template = template.key;
    card.setAttribute('aria-pressed', String(template.key === activeTemplate.key));
    const image = document.createElement('img'); image.src = template.thumbnail; image.alt = `${template.name} preview`; image.loading = 'lazy';
    const name = document.createElement('span'); name.className = 'guide-design-name'; name.textContent = template.name;
    card.append(image, name);
    card.addEventListener('click', () => { selectTemplate(template.key); $('designEditor')?.scrollIntoView({behavior:'smooth', block:'start'}); });
    track.append(card);
  });
  count.textContent = `${templates.length} designs`;
  guide.hidden = false;
}
function selectTemplate(key) {
  const template = DESIGN_TEMPLATES.find((entry) => entry.key === (typeof key === 'string' ? key : key?.dataset?.template));
  if (!template) return;
  activeTemplate = template;
  selectedLayer = null;
  document.querySelectorAll('.template-item').forEach((item) => {
    const selected = item.dataset.template === template.key;
    item.classList.toggle('active', selected); item.setAttribute('aria-pressed', String(selected));
  });
  document.querySelectorAll('.guide-design-card').forEach((item) => item.setAttribute('aria-pressed', String(item.dataset.template === template.key)));
  renderDynamicProperties(); updateMainImageTreatment(); updateSummary();
  mobileLibraryExpanded=false;syncMobileLibrary();
  revealSelectedTemplate();
}
function revealSelectedTemplate() {
  const library = $('designTemplates');
  const card = library?.querySelector(`[data-template="${activeTemplate.key}"]`);
  if (!card || library.hidden) return;
  const bounds = library.getBoundingClientRect(), item = card.getBoundingClientRect();
  if (mobileEditorQuery.matches && (item.left < bounds.left || item.right > bounds.right)) library.scrollLeft += item.left - bounds.left - (library.clientWidth-item.width)/2;
  if (!mobileEditorQuery.matches && (item.top < bounds.top || item.bottom > bounds.bottom)) {
    library.scrollTop += item.top - bounds.top - (library.clientHeight - item.height) / 2;
  }
}
const templateResourceCache = new Map();
const staticImageCache = new Map();
function chosenTemplate(template, layout) {
  if (!template.motifOptions?.length) return template;
  const option = template.motifOptions.find(o => o.value === layout?.motif) || template.motifOptions[0];
  return {...template, staticLayers: [{...template.staticLayers[0], asset:option.asset, bbox:option.bbox}]};
}
function staticImagesFor(template) {
  return Object.fromEntries((template.staticLayers||[]).map(l=>[l.key,staticImageCache.get(l.asset)]));
}
function allMovableLayers(){return [...activeTemplate.fields,...(activeTemplate.staticLayers||[])];}
let designRenderGeneration = 0;
function templateResources(template) {
  if (!templateResourceCache.has(template.key)) {
    const typefaces = [...new Set(template.fields.map(field => field.font))];
    const fontLoads = typefaces.map(async font => {
      if (!document.fonts) throw new Error('Font loading is unavailable');
      const loaded = await document.fonts.load(`32px "${font}"`);
      if (!loaded.length) throw new Error(`Template font is unavailable: ${font}`);
    });
    const artwork = [...(template.staticLayers||[]), ...(template.motifOptions||[])];
    templateResourceCache.set(template.key, Promise.all([loadImage(template.fixedTexture), ...fontLoads, ...artwork.map(async l=>{if(!staticImageCache.has(l.asset)) staticImageCache.set(l.asset,await loadImage(l.asset));})]).then(results => results[0]).catch(error => { templateResourceCache.delete(template.key); throw error; }));
  }
  return templateResourceCache.get(template.key);
}
function previewCanvas() {
  const canvas = document.createElement('canvas');
  canvas.width = canvas.height = 2048;
  canvas.className = 'template-layer-canvas';
  canvas.setAttribute('aria-hidden', 'true');
  return canvas;
}
function renderDynamicProperties() {
  const meta = $('selectedTemplateMeta'); meta.replaceChildren();
  const title = document.createElement('div'); title.className = 'selected-template-name'; title.textContent = activeTemplate.name;
  meta.append(title);
  const properties = $('dynamicProperties'); properties.replaceChildren();
  if (activeTemplate.motifOptions?.length) {
    const group=document.createElement('div'); group.className='property-group';
    const label=document.createElement('label'); label.className='property-label'; label.htmlFor='design-motif'; label.textContent=activeTemplate.motifLabel;
    const select=document.createElement('select'); select.id=label.htmlFor; select.className='property-input';
    activeTemplate.motifOptions.forEach(option=>{const el=document.createElement('option');el.value=option.value;el.textContent=option.label;select.append(el);});
    select.value=templateLayouts[activeTemplate.key].motif || activeTemplate.motifOptions[0].value;
    select.addEventListener('change',()=>{templateLayouts[activeTemplate.key].motif=select.value; templateLayouts[activeTemplate.key].rotationShift=null;renderDesignPreviews();document.dispatchEvent(new Event('ff:configuration'));});
    group.append(label,select);properties.append(group);
  }
  activeTemplate.fields.forEach((field) => {
    const group = document.createElement('div'); group.className = 'property-group';
    const label = document.createElement('label'); label.className = 'property-label'; label.htmlFor = `field-${activeTemplate.key}-${field.key}`; label.textContent = field.label;
    const input = document.createElement('input'); input.type = 'text'; input.id = label.htmlFor; input.className = 'property-input';
    input.maxLength = field.maxLength || 48; input.value = templateValues[activeTemplate.key][field.key] ?? field.value;
    input.addEventListener('focus', () => selectTextLayer(field.key));
    input.autocomplete = 'off'; input.addEventListener('input', () => {
      let value = input.value;
      if (field.maxLength === 1) value = Array.from(value)[0] || '';
      templateValues[activeTemplate.key][field.key] = value;
      renderDesignPreviews();
      document.dispatchEvent(new Event('ff:configuration'));
    });
    const row=document.createElement('div');row.className='property-input-row';const clear=document.createElement('button');clear.type='button';clear.className='property-clear';clear.setAttribute('aria-label','Clear '+field.label.toLowerCase());clear.title='Clear '+field.label.toLowerCase();clear.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16m-10 4v6m4-6v6M9 7V4h6v3m-9 0 1 13h8l1-13"/></svg>';clear.addEventListener('click',()=>{input.value='';input.dispatchEvent(new Event('input',{bubbles:true}));input.focus();});row.append(input,clear);group.append(label,row);properties.append(group);
  });
  selectedLayer=activeTemplate.fields[0]?.key;
  const overlay=$('textLayerOverlay');overlay.replaceChildren();
  for(const field of allMovableLayers()){const button=document.createElement('button');button.type='button';button.className='text-layer-handle';button.dataset.layer=field.key;button.setAttribute('aria-label','Move '+field.label.toLowerCase());button.title='Drag to move '+field.label.toLowerCase();button.addEventListener('focus',()=>selectTextLayer(field.key));button.addEventListener('click',()=>selectTextLayer(field.key));overlay.append(button);}
  const resize=document.createElement('button');resize.type='button';resize.className='text-layer-resize';resize.hidden=true;resize.setAttribute('aria-label','Resize selected text');resize.title='Drag to resize selected text';resize.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 17 17 7M10 7h7v7M7 10v7h7"/></svg>';overlay.append(resize);
  syncLayoutControls();
}
function selectTextLayer(key) { selectedLayer=key; updateLayerOverlay(); syncTextScaleControl(); }
function syncLayoutControls() {
  const layout=templateLayouts[activeTemplate.key];
  document.querySelectorAll('[data-imprint-angle]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.imprintAngle)===layout.angle)));
  syncTextScaleControl();
}
function syncTextScaleControl() {
  const control=$('textScaleControl'), input=$('textScale'), output=$('textScaleValue');
  if(!control||!input||!output)return;
  const value=Number(templateLayouts[activeTemplate.key].designScale||1);
  control.hidden=false; input.value=String(value); output.value=Math.round(value*100)+'%'; output.textContent=Math.round(value*100)+'%';
}
function updateLayerOverlay() {
  const size=activeTemplate.canvasSize;
  for(const m of layerMeasurements) {
    const handle=$('textLayerOverlay').querySelector(`.text-layer-handle[data-layer="${m.key}"]`); if(!handle)continue;
    const box=m.display;
    handle.style.left=`${box.x/size*100}%`;handle.style.top=`${box.y/size*100}%`;
    handle.style.width=`${Math.max(box.width,100)/size*100}%`;handle.style.height=`${Math.max(box.height,100)/size*100}%`;
    handle.style.transform=`translate(-50%,-50%) rotate(${box.angle}deg)`;
    handle.classList.toggle('is-selected',m.key===selectedLayer);
    handle.setAttribute('aria-pressed',String(m.key===selectedLayer));
  }
  const resize=$('textLayerOverlay').querySelector('.text-layer-resize');
  const selected=layerMeasurements.find(m=>m.key===selectedLayer);
  if(resize){
    resize.hidden=!selected;
    if(selected){const b=selected.display,a=b.angle*Math.PI/180,w=Math.max(b.width,100)/2,h=Math.max(b.height,100)/2;resize.dataset.layer=selectedLayer;resize.style.left=`${(b.x+w*Math.cos(a)+h*Math.sin(a))/size*100}%`;resize.style.top=`${(b.y+w*Math.sin(a)-h*Math.cos(a))/size*100}%`;}
  }
}
function moveTextLayer(dx,dy) {
  const layout=templateLayouts[activeTemplate.key], old=layout.offsets[selectedLayer] || {x:0,y:0};
  const angle=layout.angle*Math.PI/180, scale=layout.scale || 1;
  layout.offsets[selectedLayer]={x:old.x+(dx*Math.cos(angle)+dy*Math.sin(angle))/scale,y:old.y+(-dx*Math.sin(angle)+dy*Math.cos(angle))/scale};
  renderDesignPreviews();document.dispatchEvent(new Event('ff:configuration'));
}
function initLayoutControls() {
  document.querySelectorAll('[data-imprint-angle]').forEach(button=>button.addEventListener('click',()=>{
    templateLayouts[activeTemplate.key].angle=Number(button.dataset.imprintAngle);templateLayouts[activeTemplate.key].offsets={};templateLayouts[activeTemplate.key].rotationShift=null;syncLayoutControls();renderDesignPreviews();document.dispatchEvent(new Event('ff:configuration'));
  }));
  $('textScale')?.addEventListener('input',event=>{const layout=templateLayouts[activeTemplate.key];layout.designScale=Number(event.target.value);layout.rotationShift=null;syncTextScaleControl();renderDesignPreviews();document.dispatchEvent(new Event('ff:configuration'));});
  $('resetTextPosition').addEventListener('click',()=>{
    if(!selectedLayer || !allMovableLayers().some(layer=>layer.key===selectedLayer))return;
    const layout=templateLayouts[activeTemplate.key];
    layout.offsets[selectedLayer]={x:0,y:0};
    layout.textScales[selectedLayer]=1;
    syncTextScaleControl();renderDesignPreviews();document.dispatchEvent(new Event('ff:configuration'));
  });
  const overlay=$('textLayerOverlay');let drag=null;
  overlay.addEventListener('pointerdown',event=>{
    const handle=event.target.closest('[data-layer]');if(!handle || event.button!==0 || !window.FFEditor.renderReady)return;
    selectTextLayer(handle.dataset.layer);event.preventDefault();overlay.setPointerCapture(event.pointerId);
    const measured=layerMeasurements.find(m=>m.key===selectedLayer),paper=$('canvasNapkin').getBoundingClientRect();
    const center=measured ? {x:paper.left+measured.display.x/activeTemplate.canvasSize*paper.width,y:paper.top+measured.display.y/activeTemplate.canvasSize*paper.height} : null;
    drag={x:event.clientX,y:event.clientY,pointerId:event.pointerId,resize:handle.classList.contains('text-layer-resize'),center,startScale:templateLayouts[activeTemplate.key].textScales[selectedLayer]||1};
    handle.focus({preventScroll:true});
  });
  overlay.addEventListener('pointermove',event=>{
    if(!drag || event.pointerId!==drag.pointerId)return;
    if(drag.resize && drag.center){
      const vx=drag.x-drag.center.x,vy=drag.y-drag.center.y;
      const factor=((event.clientX-drag.center.x)*vx+(event.clientY-drag.center.y)*vy)/Math.max(1,vx*vx+vy*vy);
      templateLayouts[activeTemplate.key].textScales[selectedLayer]=Math.max(.25,Math.min(3,drag.startScale*factor));
      renderDesignPreviews();document.dispatchEvent(new Event('ff:configuration'));
    }else{
      const ratio=activeTemplate.canvasSize/$('canvasNapkin').getBoundingClientRect().width;
      moveTextLayer((event.clientX-drag.x)*ratio,(event.clientY-drag.y)*ratio);drag.x=event.clientX;drag.y=event.clientY;
    }
  });
  const stop=()=>{drag=null;};overlay.addEventListener('pointerup',stop);overlay.addEventListener('pointercancel',stop);overlay.addEventListener('lostpointercapture',stop);
  overlay.addEventListener('keydown',event=>{
    if(event.target.closest('.text-layer-resize') && ['ArrowUp','ArrowRight','ArrowDown','ArrowLeft','+','-'].includes(event.key)){event.preventDefault();const layout=templateLayouts[activeTemplate.key];const increase=['ArrowUp','ArrowRight','+'].includes(event.key);layout.textScales[selectedLayer]=Math.max(.25,Math.min(3,(layout.textScales[selectedLayer]||1)+(increase?1:-1)*(event.shiftKey?.1:.05)));renderDesignPreviews();document.dispatchEvent(new Event('ff:configuration'));return;}
    const directions={ArrowLeft:[-1,0],ArrowRight:[1,0],ArrowUp:[0,-1],ArrowDown:[0,1]};
    if(!directions[event.key])return;event.preventDefault();const [x,y]=directions[event.key];moveTextLayer(x*(event.shiftKey?40:10),y*(event.shiftKey?40:10));
  });
}
function updateMiniTemplate() {
  $('miniTemplateLabel').textContent = '';
  $('miniTemplateMark').style.backgroundImage = 'none';
}
async function renderDesignPreviews() {
  const generation = ++designRenderGeneration;
  const selectedFiles=[...($('customArtwork')?.files||[])];
  const customFiles=selectedFiles.length?selectedFiles:(window.FFEditor.retainedArtwork||[]);
  $('clearArtwork').hidden=!customFiles.length;
  $('artworkFileList').textContent=customFiles.map(f=>f.name).join(' · ');
  if(customFiles.length){
    for(const id of ['canvasDesign','productDesign']){const target=$(id);target.replaceChildren();const msg=document.createElement('div');msg.className='mr-proof-placeholder';const title=document.createElement('strong');title.textContent='Your uploaded artwork';const note=document.createElement('span');note.textContent='Proof will be sent via email';msg.append(title,note);target.append(msg);target.setAttribute('aria-busy','false');}
    $('textLayerOverlay').hidden=true;$('templateRenderStatus').textContent=customFiles.length+' artwork file(s) selected. Your emailed proof will show the final layout.';
    window.FFEditor.renderReady=true;document.dispatchEvent(new Event('ff:previewstate'));return;
  }
  $('textLayerOverlay').hidden=false;
  const template = activeTemplate;
  const values = {...templateValues[template.key]};
  const finish = currentFinish();
  const targets = [$('canvasDesign'), $('productDesign')];
  for (const target of targets) {
    target.setAttribute('aria-busy', 'true');
    if (target.dataset.template !== template.key) target.replaceChildren();
  }
  if ($('canvasDesign').dataset.template !== template.key) {
    layerMeasurements = [];
    $('textLayerOverlay').hidden = true;
  }
  const status = $('templateRenderStatus');
  window.FFEditor.renderReady = false;
  document.dispatchEvent(new Event('ff:previewstate'));
  try {
    const fixed = await templateResources(template);
    if (generation !== designRenderGeneration) return;
    const rendered = previewCanvas();
    const selectedTemplate=chosenTemplate(template,templateLayouts[template.key]);
    layerMeasurements=MotifRenderer.draw(rendered, selectedTemplate, values, fixed, finish, {...templateLayouts[template.key],staticImages:staticImagesFor(selectedTemplate)});
    Object.assign(templateLayouts[template.key],layerMeasurements.layout);
    for(const m of layerMeasurements)templateLayouts[template.key].offsets[m.key]=m.offset;
    updateLayerOverlay();
    $('textLayerOverlay').hidden = false;
    for (const target of targets) {
      const canvas = previewCanvas(); canvas.getContext('2d').drawImage(rendered, 0, 0);
      target.replaceChildren(canvas); target.dataset.template = template.key; target.setAttribute('aria-busy', 'false');
    }
    const mini = previewCanvas(); mini.getContext('2d').drawImage(rendered, 0, 0);
    $('miniTemplateMark').replaceChildren(mini); updateMiniTemplate();
    status.textContent = '';
    window.FFEditor.renderReady = true;
    document.dispatchEvent(new Event('ff:previewstate'));
    $('productStage').setAttribute('aria-label', `${selectedColor} napkin, ${template.name}: ${Object.values(values).join(', ')}`);
    document.dispatchEvent(new CustomEvent('ff:rendered', {detail:{sku:template.sku}}));
  } catch (error) {
    if (generation !== designRenderGeneration) return;
    status.textContent = 'The design preview could not load. Please refresh to try again.';
    document.dispatchEvent(new Event('ff:previewstate'));
    targets.forEach(target => { target.replaceChildren(); target.setAttribute('aria-busy', 'false'); });
  }
}

let threeModule = null, renderer = null, scene = null, camera = null, napkinMesh = null;
let animationFrameId = null, resizeObserver = null, previewGeneration = 0, dragging3D = false;
let previousPointer = { x: 0, y: 0 };
async function createTextCanvas() {
  const template = activeTemplate;
  const values = {...templateValues[template.key]};
  const finish = currentFinish();
  const canvas = previewCanvas();
  const fixed = await templateResources(template);
  const selectedTemplate=chosenTemplate(template,templateLayouts[template.key]);
  MotifRenderer.draw(canvas, selectedTemplate, values, fixed, finish, {...templateLayouts[template.key],flatFoil:true,staticImages:staticImagesFor(selectedTemplate)});
  return canvas;
}
function loadImage(src) {
  return new Promise((resolve, reject) => {
    const image = new Image(); image.crossOrigin = 'anonymous'; image.onload = () => resolve(image); image.onerror = reject; image.src = src;
  });
}
async function createPaperCanvas() {
  const canvas = document.createElement('canvas'); canvas.width = 2048; canvas.height = 2048;
  const context = canvas.getContext('2d');
  const paper = await loadImage(colorMap[productState.color].texture);
  context.drawImage(paper, 0, 0, canvas.width, canvas.height);
  return canvas;
}
function render2DFallback(message) {
  const container = $('canvas-3d'); container.replaceChildren();
  const wrapper = document.createElement('div'); wrapper.className = 'preview-fallback';
  const stage = $('productStage').cloneNode(true); stage.querySelectorAll('[id]').forEach((item) => item.removeAttribute('id')); stage.removeAttribute('id');
  const notice = document.createElement('p'); notice.textContent = message;
  wrapper.append(stage, notice); container.appendChild(wrapper);
  const original = $('productDesign').querySelector('canvas');
  const clone = stage.querySelector('.product-design-composition canvas');
  if (original && clone) clone.getContext('2d').drawImage(original, 0, 0);
}
async function show3DPreview() {
  if($('customArtwork')?.files?.length){$('templateRenderStatus').textContent='Your custom artwork proof will be sent via email. A 3D template preview is not used for uploaded artwork.';return;}
  hide3DPreview();
  $('modal3D').classList.add('active');
  const generation = ++previewGeneration;
  const container = $('canvas-3d'); container.textContent = 'Preparing preview…';
  try {
    const THREE = threeModule || await import(window.FF_ASSETS['three.module.js']);
    threeModule = THREE;
    await document.fonts.ready;
    renderDesignPreviews();
    if (generation !== previewGeneration || !$('modal3D').classList.contains('active')) return;
    scene = new THREE.Scene(); scene.background = new THREE.Color('#f4f1ec');
    const width = Math.max(1, container.clientWidth), height = Math.max(1, container.clientHeight);
    camera = new THREE.PerspectiveCamera(45, width / height, .1, 100); camera.position.set(0, 4.6, 6.8); camera.lookAt(0, 0, 0);
    renderer = new THREE.WebGLRenderer({ antialias: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2.5)); renderer.setSize(width, height, false);
    container.replaceChildren(renderer.domElement);
    // Metallic foil needs a reflected studio environment, not just diffuse lights.
    const studio = document.createElement('canvas'); studio.width = 256; studio.height = 128;
    const studioContext = studio.getContext('2d');
    const studioLight = studioContext.createLinearGradient(0, 0, 0, 128);
    studioLight.addColorStop(0, '#ffffff'); studioLight.addColorStop(.42, '#e8e5df');
    studioLight.addColorStop(.65, '#96918a'); studioLight.addColorStop(1, '#514b45');
    studioContext.fillStyle = studioLight; studioContext.fillRect(0, 0, 256, 128);
    studioContext.fillStyle = '#ffffff'; studioContext.fillRect(28, 12, 48, 64); studioContext.fillRect(178, 20, 34, 58);
    const studioTexture = new THREE.CanvasTexture(studio); studioTexture.colorSpace = THREE.SRGBColorSpace;
    studioTexture.mapping = THREE.EquirectangularReflectionMapping;
    const environmentGenerator = new THREE.PMREMGenerator(renderer);
    const environmentTarget = environmentGenerator.fromEquirectangular(studioTexture);
    scene.environment = environmentTarget.texture; scene.userData.environmentTarget = environmentTarget;
    studioTexture.dispose(); environmentGenerator.dispose();
    scene.add(new THREE.AmbientLight(0xffffff, .8));
    const light = new THREE.DirectionalLight(0xffffff, 1.2); light.position.set(3, 8, 5); scene.add(light);
    const paperTexture = new THREE.CanvasTexture(await createPaperCanvas());
    if (generation !== previewGeneration) { paperTexture.dispose(); return; }
    paperTexture.colorSpace = THREE.SRGBColorSpace; paperTexture.anisotropy = renderer.capabilities.getMaxAnisotropy();
    // The approved texture already contains the paper color; white avoids tinting it twice.
    const paperMaterial = new THREE.MeshStandardMaterial({ color: new THREE.Color('#ffffff'), map: paperTexture, roughness: 1, metalness: 0 });
    napkinMesh = new THREE.Mesh(new THREE.BoxGeometry(4, .035, 4), paperMaterial); napkinMesh.scale.setScalar(productState.size==='cocktail'?25/33:1); scene.add(napkinMesh);
    const textCanvas = await createTextCanvas();
    if (generation !== previewGeneration) return;
    const textTexture = new THREE.CanvasTexture(textCanvas); textTexture.colorSpace = THREE.SRGBColorSpace; textTexture.anisotropy = renderer.capabilities.getMaxAnisotropy();
    const isPrint = productState.finish === 'print';
    const textMaterial = new THREE.MeshStandardMaterial({ map: textTexture, transparent: true, depthWrite: false, side: THREE.DoubleSide, roughness: isPrint ? 1 : .24, metalness: isPrint ? 0 : 1 });
    const imprintGroup = new THREE.Group(); imprintGroup.position.set(0, .021, 0);
    const imprint = new THREE.Mesh(new THREE.PlaneGeometry(4, 4), textMaterial); imprint.rotation.x = -Math.PI / 2; imprintGroup.add(imprint); napkinMesh.add(imprintGroup);
    renderer.domElement.addEventListener('pointerdown', on3DPointerDown);
    renderer.domElement.addEventListener('pointermove', on3DPointerMove);
    renderer.domElement.addEventListener('pointerup', on3DPointerUp);
    renderer.domElement.addEventListener('pointercancel', on3DPointerUp);
    resizeObserver = new ResizeObserver(() => { if (!renderer || !camera) return; const w=Math.max(1,container.clientWidth),h=Math.max(1,container.clientHeight); camera.aspect=w/h; camera.updateProjectionMatrix(); renderer.setSize(w,h,false); });
    resizeObserver.observe(container);
    animate3D();
  } catch (error) {
    if (generation !== previewGeneration) return;
    hide3DResources();
    if ($('modal3D').classList.contains('active')) render2DFallback('3D preview is unavailable here. Your current design is shown above in 2D.');
  }
}
function on3DPointerDown(event) { dragging3D = true; previousPointer = { x: event.clientX, y: event.clientY }; event.currentTarget.setPointerCapture?.(event.pointerId); }
function on3DPointerMove(event) { if (!dragging3D || !napkinMesh) return; napkinMesh.rotation.y += (event.clientX - previousPointer.x) * .01; napkinMesh.rotation.x += (event.clientY - previousPointer.y) * .01; previousPointer = { x: event.clientX, y: event.clientY }; }
function on3DPointerUp() { dragging3D = false; }
function animate3D() { if (!renderer || !scene || !camera) return; animationFrameId = requestAnimationFrame(animate3D); renderer.render(scene, camera); }
function hide3DResources() {
  if (animationFrameId !== null) cancelAnimationFrame(animationFrameId); animationFrameId = null;
  if (resizeObserver) resizeObserver.disconnect(); resizeObserver = null;
  const disposed = new Set();
  if (scene) scene.traverse((object) => {
    if (object.geometry && !disposed.has(object.geometry)) { object.geometry.dispose(); disposed.add(object.geometry); }
    for (const material of [].concat(object.material || [])) {
      if (material.map && !disposed.has(material.map)) { material.map.dispose(); disposed.add(material.map); }
      if (!disposed.has(material)) { material.dispose(); disposed.add(material); }
    }
  });
  if (scene?.userData.environmentTarget) scene.userData.environmentTarget.dispose();
  if (renderer) { renderer.dispose(); renderer.domElement.remove(); renderer = null; }
  scene = null; camera = null; napkinMesh = null; dragging3D = false;
}
function hide3DPreview() { ++previewGeneration; $('modal3D').classList.remove('active'); hide3DResources(); }

window.FFEditor = { editMode:false, snapshot: () => ({...productState, sku:activeTemplate.sku, layout:JSON.parse(JSON.stringify(templateLayouts[activeTemplate.key])), sizeName:selectedSize, colorName:selectedColor, finishName:selectedFinish, requiresUV:requiresUVInk(), uvAccepted:!!$('uvInkConsent')?.checked, fields:activeTemplate.fields.map(field => ({key:field.key,label:field.label,value:templateValues[activeTemplate.key][field.key] ?? field.value}))}) };
initLayoutControls(); renderOptions(); updateSummary(); renderDynamicProperties(); updateMainImageTreatment(); initMobileEditor();
$('guideOccasionSelect')?.addEventListener('change', event => renderGuideDesigns(event.target.value));
renderGuideDesigns('all');
if (document.fonts?.ready) document.fonts.ready.then(renderDesignPreviews);
document.querySelectorAll('.summary-item').forEach((item) => item.addEventListener('click', () => showPopover(item.dataset.type)));
window.addEventListener('scroll', () => { $('stickySummary').classList.toggle('active', window.pageYOffset > $('sectionProduct').offsetTop + 90); });

// Carry the homepage's selected design into the fixed-template editor.
(() => {
  const key = new URLSearchParams(window.location.search).get('design');
  if (key && DESIGN_TEMPLATES.some(template => template.key === key)) selectTemplate(key);
})();

// Restore only a validated design read from the current cart, never URL artwork data.
window.FFEditor.restoreCartDesign = function(payload, properties) {
  const template=DESIGN_TEMPLATES.find(t=>t.sku===payload.template);
  const sizeButton=Array.from(document.querySelectorAll('#sizeOptions .size-btn')).find(b=>b.dataset.size===payload.size);
  const inkOptions=Array.from($('printInkColor').options).map(o=>o.value);
  if (!template || !sizeButton || !colorMap[payload.paper] || !finishMap[payload.finish] ||
      !/^\d+$/.test(String(payload.quantity)) || !payload.values ||
      (payload.printColor && !inkOptions.includes(payload.printColor))) throw new Error('This saved design is not compatible with the current editor.');
  const offsets={};
  for(const layer of [...template.fields,...(template.staticLayers||[])]) {
    const offset=payload.layout?.offsets?.[layer.key] || {x:0,y:0};
    if(!Number.isFinite(offset.x)||!Number.isFinite(offset.y))throw new Error('Invalid saved design position.');
    offsets[layer.key]={x:offset.x,y:offset.y};
  }
  if(![0,-45,45].includes(payload.layout?.angle))throw new Error('Invalid saved design angle.');
  if(template.motifOptions?.length && !template.motifOptions.some(o=>o.value===payload.layout?.motif))throw new Error('Invalid saved design option.');
  for(const field of template.fields)if(typeof payload.values[field.key]!=='string')throw new Error('Saved wording is incomplete.');
  window.FFEditor.retainedArtwork=[];
  if(payload.customArtwork){
    const entries=Object.entries(properties).filter(([key])=>/^Artwork [1-5]$/.test(key));
    if(!entries.length)throw new Error('The saved artwork is missing. Return to your cart for assistance.');
    window.FFEditor.retainedArtwork=entries.map(([key,url])=>{
      const u=new URL(url);if(u.protocol!=='https:'||u.hostname!=='cdn.shopify.com')throw new Error('Invalid saved artwork link.');
      return {key,url,name:decodeURIComponent(u.pathname.split('/').pop())};
    });
  }
  templateValues[template.key]=Object.fromEntries(template.fields.map(f=>[f.key,payload.values[f.key]]));
  const textScales={};for(const field of [...template.fields,...(template.staticLayers||[])])textScales[field.key]=Math.max(.25,Math.min(3,Number(payload.layout?.textScales?.[field.key])||1));
  const savedScale=Number(payload.layout.scale), savedShift=payload.layout.rotationShift;
  const validTransform=Number.isFinite(savedScale)&&savedScale>0&&savedScale<=1.2&&Number.isFinite(savedShift?.x)&&Number.isFinite(savedShift?.y)&&Math.abs(savedShift.x)<=template.canvasSize&&Math.abs(savedShift.y)<=template.canvasSize;
  templateLayouts[template.key]={angle:payload.layout.angle,scale:validTransform?savedScale:1,rotationShift:validTransform?{x:savedShift.x,y:savedShift.y}:null,designScale:Math.max(.75,Math.min(1.2,Number(payload.layout?.designScale)||1)),canvasSize:template.canvasSize,offsets,textScales};
  if(template.motifOptions?.length)templateLayouts[template.key].motif=payload.layout.motif;
  selectTemplate(template.key);selectSize(sizeButton);
  selectColor({dataset:{color:payload.paper}});selectFinish({dataset:{finish:payload.finish}});
  selectQuantity({dataset:{qty:String(payload.quantity)}});
  if(payload.printColor){productState.printColor=payload.printColor;$('printInkColor').value=payload.printColor;}
  $('proofEmail').value=properties['Proof email']||'';$('orderNotes').value=properties['Special requests']||'';
  $('uvInkConsent').checked=false;
  syncPrintControls();renderDynamicProperties();updateMainImageTreatment();updateSummary();
};

$('printInkColor').addEventListener('change',event=>{productState.printColor=event.target.value;syncPrintControls(true);updateMainImageTreatment();updateSummary();});
$('uvInkConsent').addEventListener('change',updateSummary);
['proofEmail','orderNotes'].forEach(id=>$(id)?.addEventListener('change',updateSummary));
$('customArtwork').addEventListener('change',()=>{renderDesignPreviews();showProductView();updateSummary();});
$('clearArtwork').addEventListener('click',()=>{$('customArtwork').value='';window.FFEditor.retainedArtwork=[];renderDesignPreviews();updateSummary();});

window.FFEditor.exportFiles=async function(state){
  const template=DESIGN_TEMPLATES.find(t=>t.sku===state.sku);if(!template)throw new Error('Design not found for production export.');
  const spec=MotifProduction.spec(state.size),fixed=await templateResources(template);
  const values=Object.fromEntries(state.fields.map(f=>[f.key,f.value]));
  const selectedTemplate=chosenTemplate(template,state.layout),staticImages=staticImagesFor(selectedTemplate);
  const canvas=document.createElement('canvas');canvas.width=canvas.height=spec.pixels;
  const face=document.createElement('canvas');face.width=face.height=spec.facePixels;
  const finish=state.finish==='print'?{...finishMap.print,body:state.printColor}: {key:'print',body:'#000000'};
  MotifRenderer.draw(face,selectedTemplate,values,fixed,finish,{...state.layout,flatFoil:true,staticImages});
  canvas.getContext('2d').drawImage(face,0,0);
  const preview=document.createElement('canvas');preview.width=preview.height=spec.facePixels;
  const pctx=preview.getContext('2d');pctx.drawImage(await loadImage(colorMap[state.color].texture),0,0,spec.facePixels,spec.facePixels);
  const previewInk=state.finish==='print'?{...finishMap.print,body:state.printColor}:finishMap[state.finish];
  MotifRenderer.draw(face,selectedTemplate,values,fixed,previewInk,{...state.layout,staticImages});pctx.drawImage(face,0,0);
  const prefix='MotifRevel-'+state.sku+'-'+spec.cm+'cm';
  return {production:await MotifProduction.pngFile(canvas,prefix+'-300ppi-PRODUCTION.png'),preview:await MotifProduction.pngFile(preview,prefix+'-folded-PREVIEW.png'),spec};
};
